import { STAFF_ANCHORS, STAFF_CONTEXTS } from './anchors'
import { SHARED_ANCHORS } from '../shared/anchors'
import { withScopes } from '../shared/scopes'
import type { IOnboardingScenario } from '../../types/IOnboardingScenario'
import type { IOnboardingStep } from '../../types/IOnboardingStep'

const { nav, table, structure, edit, settings, activity } = STAFF_ANCHORS
const ctx = STAFF_CONTEXTS

const steps: IOnboardingStep[] = [
  { id: 'staff.intro', anchors: [], context: ctx.table },
  { id: 'staff.add', anchors: [table.add], context: ctx.table },
  { id: 'staff.statistics', anchors: [table.statistics], context: ctx.table },
  { id: 'staff.structure', anchors: [table.structure], context: ctx.table },
  ...withScopes(['structureModal'], [
    { id: 'staff.structure.tree', anchors: [structure.tree], context: ctx.table, placement: 'auto' },
  ]),
  { id: 'staff.settings', anchors: [table.settings], context: ctx.table, condition: 'staff.canSettings' },
  ...withScopes(['settingsPage'], [
    { id: 'staff.settings.tabs', anchors: [settings.tabs], context: ctx.settings, condition: 'staff.canSettings', placement: 'bottom' },
    { id: 'staff.settings.content', anchors: [settings.content], context: ctx.settings, condition: 'staff.canSettings', placement: 'auto' },
  ]),
  { id: 'staff.navSettings', anchors: [nav.settings], context: ctx.table, condition: 'staff.canSettings', placement: 'right' },
  { id: 'toolbar.onboarding', anchors: [SHARED_ANCHORS.toolbar.onboarding], context: ctx.table },
  { id: 'staff.search', anchors: [table.search], context: ctx.table },
  { id: 'staff.filters', anchors: [table.filterFirst, table.filterLast], context: ctx.table, condition: 'staff.canViewActivity' },
  { id: 'staff.filtersBasic', anchors: [table.filterBasicFirst, table.filterBasicLast], context: ctx.table, condition: 'staff.cannotViewActivity' },
  { id: 'staff.resetFilters', anchors: [table.resetFilters], context: ctx.table },
  { id: 'staff.hideInactive', anchors: [table.hideInactive], context: ctx.table },
  { id: 'staff.bulk.roles', anchors: [table.bulkRoles], context: ctx.table },
  { id: 'staff.bulk.access', anchors: [table.bulkBlock, table.bulkRestore], context: ctx.table },
  { id: 'staff.bulk.export', anchors: [table.bulkExport], context: ctx.table },
  { id: 'staff.bulk.reports', anchors: [SHARED_ANCHORS.toolbar.reports], context: ctx.table },
  /* Пункты меню строки скрыты до открытия меню, поэтому вариант текста выбирается по правам, а не по наличию элемента */
  { id: 'staff.rowMenu.basic', anchors: [table.rowMenu], context: ctx.table, condition: 'staff.menuBasic', placement: 'right' },
  { id: 'staff.rowMenu.view', anchors: [table.rowMenu], context: ctx.table, condition: 'staff.menuView', placement: 'right' },
  { id: 'staff.rowMenu.edit', anchors: [table.rowMenu], context: ctx.table, condition: 'staff.menuEdit', placement: 'right' },
  { id: 'staff.rowMenu.full', anchors: [table.rowMenu], context: ctx.table, condition: 'staff.menuFull', placement: 'right' },
  ...withScopes(['editDialog'], [
    { id: 'staff.edit.personal', anchors: [edit.personalFirst, edit.personalLast], context: ctx.table, condition: 'staff.canEditEmployee', placement: 'left' },
    { id: 'staff.edit.structure', anchors: [edit.structure], context: ctx.table, condition: 'staff.canEditEmployee', placement: 'left' },
    { id: 'staff.edit.roles', anchors: [edit.roles], context: ctx.table, condition: 'staff.canEditEmployee', placement: 'left' },
    { id: 'staff.edit.signatures', anchors: [edit.signatures], context: ctx.table, condition: 'staff.canEditEmployee', placement: 'left' },
    { id: 'staff.edit.save', anchors: [edit.save], context: ctx.table, condition: 'staff.canEditEmployee', placement: 'top' },
  ]),
  { id: 'staff.demoRow', anchors: [table.demoRow], context: ctx.table, condition: 'staff.canViewActivity' },
  ...withScopes(['activityPage'], [
    { id: 'staff.activity.profile', anchors: [activity.profile], context: ctx.activity, condition: 'staff.canViewActivity', placement: 'bottom' },
    { id: 'staff.activity.edit', anchors: [activity.edit], context: ctx.activity, condition: 'staff.canViewActivity', placement: 'bottom' },
    { id: 'staff.activity.analytics', anchors: [activity.analytics], context: ctx.activity, condition: 'staff.canViewActivity', placement: 'auto' },
    { id: 'staff.activity.actions', anchors: [activity.actions], context: ctx.activity, condition: 'staff.canViewActivity', placement: 'top' },
  ]),
]

export const staffScenarios: IOnboardingScenario[] = [
  {
    id: 'staff',
    section: 'employee',
    isMain: true,
    scopes: {
      structureModal: {
        open: { context: ctx.table, action: 'openStructure' },
        close: { context: ctx.table, action: 'closeStructure' },
      },
      editDialog: {
        open: { context: ctx.table, action: 'openDemoEdit' },
        close: { context: ctx.table, action: 'closeEdit' },
      },
      settingsPage: {
        open: { context: ctx.table, action: 'openSettings' },
        close: { context: ctx.settings, action: 'backToStaff' },
      },
      activityPage: {
        open: { context: ctx.table, action: 'openDemoActivity' },
        close: { context: ctx.activity, action: 'backToStaff' },
      },
    },
    steps,
  },
]
